export const FLAG_GETTING_EXTRAORDINARY_MOVEMENTS =
  'FLAG_GETTING_EXTRAORDINARY_MOVEMENTS';
export const GET_EXTRAORDINARY_MOVEMENTS = 'GET_EXTRAORDINARY_MOVEMENTS';
export const CLEAR_EXTRAORDINARY_MOVEMENTS = 'CLEAR_EXTRAORDINARY_MOVEMENTS';
export const FLAG_EXTRAORDINARY_MOVEMENT_ACTIVITY =
  'FLAG_EXTRAORDINARY_MOVEMENT_ACTIVITY';
export const GET_EXTRAORDINARY_MOVEMENT = 'GET_EXTRAORDINARY_MOVEMENT';
export const CLEAR_EXTRAORDINARY_MOVEMENT = 'CLEAR_EXTRAORDINARY_MOVEMENT';
